import JSZip from 'jszip';
import { Model3DXML, parse3DXML } from '@gkn-ili/cad-model';
import { saveAs } from 'file-saver';
import { SaveFile } from '@gkn-ili/views/dist/mocks/order-service';

export async function importFromZip(file: File): Promise<{
  fileName: string;
  saveFile: SaveFile;
  model: Model3DXML | null;
  rawModel: Blob | null;
}> {
  const jszip = new JSZip();

  const zip = await jszip.loadAsync(file);
  let orderViewP: Promise<SaveFile> | undefined;
  let modelP: Promise<{ blob: Blob; model: Model3DXML }> | undefined;

  zip.forEach((path, zippedFile) => {
    if (path.endsWith('.json')) {
      orderViewP = zippedFile.async('string').then((v) => JSON.parse(v));
    }
    if (path.endsWith('.3dxml')) {
      modelP = zippedFile.async('blob').then(async (blob) => {
        const model = await parse3DXML(blob);
        return { blob, model };
      });
    }
  });

  if (!orderViewP) {
    throw new Error('Did not find a suitable root file');
  }

  const model = await modelP;
  const orderView = await orderViewP;

  return {
    fileName: file.name,
    saveFile: orderView,
    model: model ? model.model : null,
    rawModel: model ? model.blob : null,
  };
}

export async function import3DXML(file: File): Promise<{
  modelFile: string;
  model: Model3DXML;
  rawModel: Blob;
}> {
  const model = await parse3DXML(file);
  const modelFile = file.name;

  return { modelFile, model, rawModel: file };
}

export async function exportToZip(name: string, data: SaveFile, rawModel: Blob | null) {
  const zip = new JSZip();

  zip.file('main.json', JSON.stringify(data, null, '\t'));
  if (rawModel) {
    zip.file(data.modelFile, rawModel);
  }

  const file = await zip.generateAsync({ type: 'blob' });

  saveAs(file, `${name}.zip`);
}
